/**
 * Favorites Loading Skeleton
 * Shows skeleton UI for favorites page with TabBar during lazy loading
 */

import { AppShellSkeleton } from '@/components/layout/AppShellSkeleton';

export function FavoritesLoadingSkeleton() {
  return <AppShellSkeleton showHeader headerTitle="Избранное" contentType="cards" />;
}

export default FavoritesLoadingSkeleton;
